/**
 * Initialize Hotjar - Jobseeker pages only
 * @param pagePath - The path of the page to initialize Hotjar on
 * @returns void
 */
export const initializeJobseekerHotjar = (pagePath?: string) => {
  if (typeof window === 'undefined') return;

  const currentPath = pagePath || window.location.pathname;
  console.log(`[Hotjar] Function called for page: ${currentPath}`, new Date().toISOString());

  // Check if Hotjar is already initialized
  if ((window as any).hj) {
    // console.log(`[Hotjar] Already initialized - tracking state change for: ${currentPath}`);
    // Track page change even if already initialized
    (window as any).hj('stateChange', currentPath);
    console.log(`[Hotjar] State change tracked: ${currentPath}`);
    return;
  }

//   console.log(`[Hotjar] Initializing on page: ${currentPath}`);

  (function(h: any, o: any, t: string, j: string) {
    let a: HTMLElement | null;
    let r: HTMLScriptElement;
    
    h.hj = h.hj || function() { (h.hj.q = h.hj.q || []).push(arguments); };
    h._hjSettings = { hjid: 6389465, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = true;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    
    // Log when script loads
    r.onload = () => {
    //   console.log(`[Hotjar] Script loaded successfully on ${currentPath}`);
    //   console.log(`[Hotjar] hj object:`, (window as any).hj);
      // Track initial page view
      (window as any).hj('stateChange', currentPath);
    //   console.log(`[Hotjar] Initial state change tracked: ${currentPath}`);
    };
    
    r.onerror = () => {
      console.error(`[Hotjar] Failed to load script on ${currentPath}`);
    };
    
    if (a) {
      a.appendChild(r);
    }
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
};